// @flow

import React from 'react';
import type { ComponentType } from 'react';
import styled, { css } from 'styled-components';
import { breakpointsToArray, media } from '@leasen_nl/listo/src/helpers';
import {
  CategoryTitle, Feedback, QuestionDetail, SubCategoryList,
} from '@leasen_nl/listo/src/components/faq';
import type {
  FAQCategoryWithCategories, FAQItem, FAQParent, FAQCategory,
} from '@leasen_nl/listo/src/types/faq';
import type { StyledComponentProps } from '@leasen_nl/listo/src/types';
import type { Theme } from '@types/index';
import Row from '../row';
import Column from '../column';

const SideColumn: ComponentType<*> = styled<typeof Column, Theme, _>(Column)`
  > * {
    padding: 2rem 0;
  }

  ${media.lg(css`
    > * {
      padding: 0;
    }
  `)}
`;

const StyledFeedback: ComponentType<*> = styled<typeof Feedback, Theme, _>(Feedback)`
  border-top: 1px solid ${(props: StyledComponentProps) => props.theme.faq.feedback.borderColor};
  padding-top: 1.5rem;
`;

type OwnProps = {|
  rootCategory: FAQCategoryWithCategories,
  parent: ?FAQParent,
  item: FAQItem,
|};

type Props = OwnProps;

const ActiveItem = ({
  rootCategory,
  parent,
  item,
}: Props) => (
  <section>
    <Row>
      <Column width={1}>
        <CategoryTitle
          title={rootCategory.name}
          description={rootCategory.description}
          icon={rootCategory.icon}
        />
      </Column>
    </Row>
    <Row>
      <SideColumn
        width={breakpointsToArray({
          default: 12 / 12,
          lg: 4 / 12,
        })}
      >
        <SubCategoryList
          categories={(rootCategory.categories || []).map(
            (category: FAQCategory) => ({
              active: category.active,
              name: category.name,
              url: category.permalink,
            }),
          )}
          parentName={parent && parent.title}
          parentUrl={parent && parent.permalink}
        />
      </SideColumn>
      <Column
        width={breakpointsToArray({
          default: 12 / 12,
          lg: 8 / 12,
        })}
      >
        {item && (
          <QuestionDetail
            question={item.title}
            answer={item.content}
          />
        )}
        <StyledFeedback />
      </Column>
    </Row>
  </section>
);

export default ActiveItem;
